import { computed, inject, Injectable, signal } from '@angular/core';
import { CartCheckoutHandler } from 'cart-data';
import { OrdersService } from 'lib-orders';

/**
 * Punchout replacement for the cart's checkout action. A punchout user never sees the
 * checkout form: the cart is handed back to the buyer's procurement system instead.
 *
 * `OrdersService` resolves to `PunchoutOrdersService` here (see providePunchoutFeature), whose
 * submitOrder() POSTs the punchout cart to the cXML webservice and leaves the app.
 */
@Injectable()
export class PunchoutCartCheckoutHandler implements CartCheckoutHandler {
  private readonly _ordersService = inject(OrdersService);
  private readonly _submitting = signal(false);

  public readonly busy = this._submitting.asReadonly();
  public readonly label = computed(() => (this._submitting() ? 'Submitting...' : 'Return to Procurement System'));

  public async checkout(): Promise<void> {
    this._submitting.set(true);
    try {
      await this._ordersService.submitOrder();
    } finally {
      this._submitting.set(false);
    }
  }
}
